var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCustomerChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5137 16.666H15.9222C16.8804 16.666 17.6426 16.2294 18.3269 15.619C20.0654 14.0682 15.9788 12.4993 14.5837 12.4993M12.917 4.22332C13.1062 4.18579 13.3027 4.16602 13.5043 4.16602C15.0209 4.16602 16.2503 5.2853 16.2503 6.66602C16.2503 8.04673 15.0209 9.16602 13.5043 9.16602C13.3027 9.16602 13.1062 9.14624 12.917 9.10871",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73443 13.4253C2.75195 13.9518 0.175948 15.0269 1.7449 16.3722C2.51133 17.0294 3.36492 17.4993 4.4381 17.4993H10.5619C11.6351 17.4993 12.4887 17.0294 13.2551 16.3722C14.8241 15.0269 12.2481 13.9518 11.2656 13.4253C8.96167 12.1907 6.03832 12.1907 3.73443 13.4253Z",
    stroke: "#242428",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 6.24935C10.8333 8.0903 9.34095 9.58268 7.5 9.58268C5.65905 9.58268 4.16667 8.0903 4.16667 6.24935C4.16667 4.4084 5.65905 2.91602 7.5 2.91602C9.34095 2.91602 10.8333 4.4084 10.8333 6.24935Z",
    stroke: "#242428",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerChatbot);
export default __webpack_public_path__ + "static/media/icon-customer-chatbot.b89164e1d46818ab0718368c203058ed.svg";
export { ForwardRef as ReactComponent };